// Lightweight GA4 event helper (gtag is loaded in public/index.html)
export function trackEvent(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}
